export enum CardSwapStatusCode {

    CardCollectNotificationFailed = 'CARD_COLLECT_NOTIFICATION_FAILED',
    CreatingNewCard = 'CREATING_NEW_CARD',
    DeactivatingOldCards = 'DEACTIVATING_OLD_CARDS',
    NewCardCollected = 'NEW_CARD_COLLECTED',
    NewCardCreated = 'NEW_CARD_CREATED',
    OldCardsDeactivated = 'OLD_CARDS_DEACTIVATED',
    ReadyToCollect = 'READY_TO_COLLECT',
    ReturningOldCards = 'RETURNING_OLD_CARDS',
    
};


export const cardSwapStatusCodes: { [ key: string ]: string } = { };

cardSwapStatusCodes[ CardSwapStatusCode.CardCollectNotificationFailed ] = 'Card-Collect Notification Failed';
cardSwapStatusCodes[ CardSwapStatusCode.CreatingNewCard ] = 'Pending New Card Creation';
cardSwapStatusCodes[ CardSwapStatusCode.DeactivatingOldCards ] = 'Pending Old Cards Deactivation';
cardSwapStatusCodes[ CardSwapStatusCode.NewCardCollected ] = 'New Card Collected';
cardSwapStatusCodes[ CardSwapStatusCode.NewCardCreated ] = 'New Card Created';
cardSwapStatusCodes[ CardSwapStatusCode.OldCardsDeactivated ] = 'Old Cards Deactivated';
cardSwapStatusCodes[ CardSwapStatusCode.ReadyToCollect ] = 'Ready For Collection';
cardSwapStatusCodes[ CardSwapStatusCode.ReturningOldCards ] = 'Pending Old Cards Return';